import { Container } from 'react-bootstrap';
import { Redirect, Route, Switch } from 'react-router';
import PrivateRoute from '../general/PrivateRoute';
import NavigationBar from '../Navbar/NavigationBar';
import Request from '../../pages/Request/Request';
import RequestList from '../../pages/Request/RequestList';
import SuccessCreated from '../../pages/Request/SuccessCreated';
import { useAuth } from '../general/ProvideAuth';
import RequestViewer from '../../pages/Request/RequestViewer';
import NotFound from '../../pages/NotFound/NotFound';
import UserProfile from '../../pages/UserProfile/UserProfile';
import UsersHome from '../../pages/UsersHome/UsersHome';
import UsersInstructions from '../../pages/UsersInstructions/UserInstructions';
import UsersManuals from '../../pages/UsersManuals/UsersManuals';
import './MainLayout.css';

function MainLayout() {
  const auth = useAuth();
  return (
    <>
      <NavigationBar />
      <Container className='mainLayoutWrapper'>
        <Switch>
          <PrivateRoute exact path="/">
            {auth.user.role === 'admin' ? <Redirect to="/admin" /> : <Redirect to="/home" />}
          </PrivateRoute>
          <PrivateRoute exact path="/home">
            <UsersHome />
          </PrivateRoute>
          <PrivateRoute exact path="/instructions">
            <UsersInstructions />
          </PrivateRoute>
          <PrivateRoute exact path="/manuals">
            <UsersManuals />
          </PrivateRoute>
          <PrivateRoute exact path="/request">
            <Request />
          </PrivateRoute>
          <PrivateRoute exact path="/request/list">
            <RequestList />
          </PrivateRoute>
          <PrivateRoute exact path="/request/success/:id">
            <SuccessCreated />
          </PrivateRoute>
          <PrivateRoute exact path="/request/:id">
            <RequestViewer />
          </PrivateRoute>
          <PrivateRoute exact path="/user">
            <UserProfile />
          </PrivateRoute>
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </Container>
    </>
  );
}

export default MainLayout;
